module.exports = "/_next/static/images/kickoff-logo-dark-44c033782cb312b54390880c202d9233.svg";